import React from 'react'
import styles from './contentWrapper.styles.css'
import Logo from './logo/logo.component.js'

export default class ContentWrapper extends React.PureComponent {

  render () {
    return (
      <Background>
        <LoginCard>
          <HeaderAndContent
            bannerTextOverride={this.props.bannerTextOverride}
            isWhiteLabelDomain={this.props.isWhiteLabelDomain}
          >
            {this.props.children}
          </HeaderAndContent>
        </LoginCard>
      </Background>
    )
  }
}

export class LoginCard extends React.Component {
  render () {
    return (
      <div style={this.props.styleOverride} className={`cps-fixed-focus cps-card ${styles.card} cps-card__height-2`}>
        {this.props.children}
      </div>
    )
  }
}

export class Background extends React.Component {
  render () {
    return (
      <div className={`${styles.fullPage}`}>
        {this.props.children}
      </div>
    )
  }
}

export class ContentWrapperNoHeader extends React.Component {
  render () {
    return (
      <Background>
        <LoginCard>
          <ContentWrapperOnly>
            {this.props.children}
          </ContentWrapperOnly>
        </LoginCard>
      </Background>
    )
  }
}

export class ContentWrapperOnly extends React.Component {
  render () {
    return (
      <div className={`${styles.contentWrapper}`}>
        {this.props.children}
      </div>
    )
  }
}

export class HeaderAndContent extends React.Component {
  static defaultProps = {
    includeStyles: true
  }
  render () {
    return (
      <div className={`${this.props.includeStyles ? styles.contentWrapper : ''}`}>
        <div className={`${styles.welcome} cps-padding-bottom-32`}>
          {this.renderHeader()}
        </div>
        {this.props.children}
      </div>
    )
  }

  renderHeader = () => {
    if (this.props.bannerTextOverride) {
      return this.props.bannerTextOverride;
    } else if (this.props.isWhiteLabelDomain) {
      return null;
    } else {
      return <Logo />;
    }
  }
}
